import { BADGE_STATUS, type BadgeStatus } from "@regal-voice/ui";
import { NamedConditionalTypes, Segment, SegmentType } from "Types/Segment";

export function getConditionalTypes(): NamedConditionalTypes {
    return [
        { value: "contactAttribute", name: "Contact Attribute" },
        { value: "customEvent", name: "Custom Event" },
    ];
}

export function getSegmentState(segment: Segment): { label: string; status: BadgeStatus } {
    return {
        label: segment.type === SegmentType.DYNAMIC ? "dynamic" : "static",
        status: segment.type === SegmentType.DYNAMIC ? BADGE_STATUS.DYNAMIC : BADGE_STATUS.STATIC,
    };
}
